import { client } from "./index";

// Lines come back as full products plus qty, priced as of now
export const getCart = () => client.get("/storefront/cart").then((res) => res.data.items);

// items: [{ productId, qty }]. Replaces the whole saved cart.
export const saveCart = (items) => client.put("/storefront/cart", { items }).then((res) => res.data.items);

export const clearCart = () => client.delete("/storefront/cart").then((res) => res.data);
